import * as R from 'ramda';

import { fieldNames, fieldsMenuItems } from './fields';
import { multipleChoiceDisplayOptions } from './multipleChoice';
import { paragraphDisplayOptions } from './paragraph';
import { titleDescriptionDisplayOptions } from './titleDescription';
import { textDisplayOptions } from './text';
import { generateNewField } from './generateNewField';
import { checkboxDisplayOptions } from './checkbox';
import { dropdownDisplayOptions } from './select';
import { linearScaleDisplayOptions } from './linearScale';
import { dividerDisplayOptions } from './divider';
import { dateDisplayOptions } from './date';
import { timeDisplayOptions } from './time';

export const newField = (value) => generateNewField(value);

export const aggregateDisplayOptions = R.mergeAll([
    { [fieldNames.select]: dropdownDisplayOptions },
    { [fieldNames.checkbox]: checkboxDisplayOptions },
    { [fieldNames.multipleChoice]: multipleChoiceDisplayOptions },
    { [fieldNames.paragraph]: paragraphDisplayOptions },
    { [fieldNames.title]: titleDescriptionDisplayOptions },
    { [fieldNames.text]: textDisplayOptions },
    { [fieldNames.linearScale]: linearScaleDisplayOptions },
    { [fieldNames.divider]: dividerDisplayOptions },
    { [fieldNames.date]: dateDisplayOptions },
    { [fieldNames.time]: timeDisplayOptions },
    { fieldsMenuItems },
    { fieldNames }
]);

export { fieldNames };
